import { createReducer, on } from '@ngrx/store';

import * as actions from '../actions/setting.actions';
import { featureKey, initialState, IState } from '../states/setting.state';

export { featureKey, IState };

export const reducer = createReducer(
  initialState,
  on(actions.SET_APP_STATE, (state, { appState }) => ({
    ...state,
    appType: appState,
  })),
  on(actions.SIGN_UP_SUCCESS, (state, { valid }) => ({
    ...state,
    validToken: valid,
  })),
);
